module.exports = __webpack_public_path__ + "static/pn-3db9944f91dbb228f897999ad081f1d7.svg";